import type { SettingDef, SelectSetting } from "./types";

export const SETTINGS_SCHEMA = {
  // ── 화면 설정
  "appearance.theme": {
    type: "select",
    scope: "user",
    default: "system",
    options: [
      { value: "light", label: "라이트" },
      { value: "dark", label: "다크" },
      { value: "system", label: "시스템 설정" },
    ],
    group: "appearance",
    order: 10,
    title: "테마",
    description: "앱 전체 색상 모드",
  },
  "appearance.language": {
    type: "select",
    scope: "user",
    default: "ko",
    options: [
      { value: "ko", label: "한국어" },
      { value: "en", label: "English" },
    ],
    group: "appearance",
    order: 20,
    title: "언어",
    description: "인터페이스 표시 언어",
  },
  "appearance.fontSize": {
    type: "number",
    scope: "user",
    default: 13,
    min: 11,
    max: 18,
    group: "appearance",
    order: 30,
    title: "폰트 크기",
  },

  // ── 알림 설정
  "notification.trainDone": {
    type: "boolean",
    scope: "user",
    default: true,
    group: "notification",
    order: 10,
    title: "학습 완료 알림",
    description: "학습이 완료되면 알림을 표시합니다",
  },
  "notification.trainFail": {
    type: "boolean",
    scope: "user",
    default: true,
    group: "notification",
    order: 20,
    title: "학습 실패 알림",
    description: "오류 발생 시 알림을 표시합니다",
  },
  "notification.browser": {
    type: "boolean",
    scope: "device",
    default: false,
    group: "notification",
    order: 30,
    title: "브라우저 알림 허용",
    description: "화면 밖에서도 알림을 받습니다",
  },

  // ── 이미지 뷰어 설정
  "viewer.defaultMode": {
    type: "select",
    scope: "user",
    default: "original",
    options: [
      { value: "original", label: "원본" },
      { value: "scoremap", label: "스코어맵" },
      { value: "compare", label: "비교" },
    ],
    group: "image",
    order: 10,
    title: "기본 뷰 모드",
  },
  "viewer.showOriginal": {
    type: "boolean",
    scope: "user",
    default: false,
    group: "image",
    order: 20,
    title: "원본 이미지 기본 표시",
    description: "비교 모드 진입 시 원본을 함께 표시합니다",
  },
  "viewer.lensZoom": {
    type: "number",
    scope: "device",
    default: 2.5,
    min: 1,
    max: 5,
    group: "image",
    order: 30,
    title: "렌즈 줌 배율",
    description: "스코어맵 렌즈 확대 배율",
  },
  "viewer.showOkHeatmap": {
    type: "boolean",
    scope: "user",
    default: false,
    group: "image",
    order: 40,
    title: "OK 이미지 히트맵 뷰어",
    description: "OK로 라벨링된 이미지에도 AI 히트맵(이상 추정 영역)을 함께 표시합니다",
  },
} as const satisfies Record<string, SettingDef>;

export type Schema = typeof SETTINGS_SCHEMA;

/** action을 제외한 키 */
type ValueKeys = {
  [K in keyof Schema]: Schema[K] extends { type: "action" } ? never : K;
}[keyof Schema];

type ValueOf<D> = D extends { type: "boolean" }
  ? boolean
  : D extends { type: "number" }
    ? number
    : D extends { type: "select"; options: readonly { value: infer V }[] }
      ? V
      : never;

export type SettingsValues = { [K in ValueKeys]: ValueOf<Schema[K]> };
export type SettingKey = keyof SettingsValues;

/** 런타임 조회용. as const 때문에 readonly라 캐스팅 한 번 */
export const SCHEMA_MAP = SETTINGS_SCHEMA as unknown as Record<string, SettingDef>;
